import autobind from 'autobind-decorator';
import * as React from 'react';
import { hashHistory } from 'react-router';

import States from 'login-constants/states';
import * as userUtils from 'login-utils/userUtils';
import TermsOfService from './TermsOfService';
import TermsOfServicePixelTracker from './TermsOfServicePixelTracker';

export interface TermsOfServiceContainerState {
  isSubmitting: boolean;
}

@autobind
class TermsOfServiceContainer extends React.Component<{}, TermsOfServiceContainerState> {
  constructor(props: {}) {
    super(props);
    this.state = { isSubmitting: false };
  }

  componentWillMount() {
    // We shouldn't be in this state unless we have a current user.
    if (!userUtils.getCurrentUser()) {
      return hashHistory.push(States.LOGIN);
    }
  }

  onSubmit(e) {
    // Do nothing with event since this is a regular HTML form submission.
    this.setState({ isSubmitting: true });
  }

  render() {
    return (
      <div>
        <TermsOfService onSubmit={this.onSubmit} isSubmitting={this.state.isSubmitting} />
        <TermsOfServicePixelTracker />
      </div>
    );
  }
}

export default TermsOfServiceContainer;
